import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=2c30d23b&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=js&"
export * from "./Note.vue?vue&type=script&lang=js&"
import style0 from "./Note.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Note.vue?vue&type=style&index=1&id=2c30d23b&lang=scss&scoped=true&"
import style2 from "./Note.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30d23b",
  null
  
)

export default component.exports